const pageNameKey = "bulkEditDataAcquisitionModal";

export const bulkEditDataAcquisitionModalEn = {
  [pageNameKey]: {
    subHeaderSubTitle: "Edit Data Acquisition Type",
    subTitle: "Set data acquisition type for selected items",
    applyButton: "Apply Changes",
    cancelButton: "Cancel",
    dataAcquisitionTypeDropDownLabel: "Data Acquisition Type",
    updateEveryInputAndDropDownLabel: "Update every",
  },
};

export const bulkEditDataAcquisitionModalPtBr = {
  [pageNameKey]: {
    subHeaderSubTitle: "Editar tipo de aquisição de dados",
    subTitle: "Defina o tipo de aquisição de dados para os itens selecionados",
    applyButton: "Aplicar alterações",
    cancelButton: "Cancelar",
    dataAcquisitionTypeDropDownLabel: "Tipo de aquisição de dados",
    updateEveryInputAndDropDownLabel: "Atualizar a cada",
  },
};

export const bulkEditDataAcquisitionModalDe = {
  [pageNameKey]: {
    subHeaderSubTitle: "Datenerfassungstyp bearbeiten",
    subTitle: "Datenerfassungstyp für ausgewählte Elemente festlegen",
    applyButton: "Änderungen übernehmen",
    cancelButton: "Abbrechen",
    dataAcquisitionTypeDropDownLabel: "Daten-Erfassungs-Typ",
    updateEveryInputAndDropDownLabel: "Aktualisieren alle",
  },
};

export const bulkEditDataAcquisitionModalZhHans = {
  [pageNameKey]: {
    subHeaderSubTitle: "编辑数据采集类型",
    subTitle: "为选定项目设置数据采集类型",
    applyButton: "应用更改",
    cancelButton: "取消",
    dataAcquisitionTypeDropDownLabel: "数据采集类型",
    updateEveryInputAndDropDownLabel: "每隔多久更新一次",
  },
};

export const bulkEditDataAcquisitionModalIt = {
  [pageNameKey]: {
    subHeaderSubTitle: "Modifica la modalità di acquisizione dati",
    subTitle:
      "Imposta la modalità di acquisizione dati per gli elementi selezionati",
    applyButton: "Applica modifiche",
    cancelButton: "Cancellare",
    dataAcquisitionTypeDropDownLabel: "Modalità di acquisizione dati",
    updateEveryInputAndDropDownLabel: "Aggiorna ogni",
  },
};

export const bulkEditDataAcquisitionModalEs = {
  [pageNameKey]: {
    subHeaderSubTitle: "Editar tipo de adquisición de datos",
    subTitle:
      "Establecer el tipo de adquisición de datos para los elementos seleccionados",
    applyButton: "Aplicar cambios",
    cancelButton: "Cancelar",
    dataAcquisitionTypeDropDownLabel: "Tipo de adquisición de datos",
    updateEveryInputAndDropDownLabel: "Actualizar cada",
  },
};

export const bulkEditDataAcquisitionModalNl = {
  [pageNameKey]: {
    applyButton: "Wijzigingen toepassen",
    cancelButton: "Annuleren",
    dataAcquisitionTypeDropDownLabel: "Type gegevensverzameling",
    subHeaderSubTitle: "Type gegevensverzameling bewerken",
    subTitle: "Type gegevensverzameling voor geselecteerde elementen instellen",
    updateEveryInputAndDropDownLabel: "Alles bewerken",
  },
};

export const bulkEditDataAcquisitionModalTr = {
  [pageNameKey]: {
    applyButton: "Değişiklikleri Uygula",
    cancelButton: "İptal etmek",
    dataAcquisitionTypeDropDownLabel: "Veri Toplama Türü",
    subHeaderSubTitle: "Veri Toplama Türünü Düzenle",
    subTitle: "Seçilen öğeler için veri toplama türünü ayarlayın",
    updateEveryInputAndDropDownLabel: "Güncelleme sıklığı",
  },
};
